import React from 'react'
import { useLocation } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { useBreakpoint } from '@factorialco/deprecated-design-system'
import { Download, ExternalLink } from '@factorialco/f0-react/icons/app'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { Navattic as NavatticComponent } from 'modules/marketplace_modules/components/Revamp/Navattic'
import { ResourceAction, SidePanelProps } from 'modules/marketplace_modules/components/Revamp/types'
import { downloadPdf } from 'modules/marketplace_modules/components/utils/downloadPdf'

import Navattic from './_Navattic'
import Resources from './_Resources'
import SimilarCompanies from './_SimilarCompanies'

const SidePanel: React.FC<SidePanelProps> = ({
  pitchDeck,
  module,
  isAuthorized,
  setupGuide,
  benefit,
  moduleName,
  navatticImage,
  navatticUrl,
  navatticTitle,
  moduleSlug,
}) => {
  const { isMobile } = useBreakpoint()
  const { pathname, search } = useLocation()
  const params = new URLSearchParams(search)
  const action = params.get('action')

  const shouldShowNavattic = navatticUrl && navatticImage

  const { openDemo, modal: navatticModal } = NavatticComponent({
    demoUrl: navatticUrl || '',
    title: navatticTitle || '',
    moduleSlug: moduleSlug || '',
    isOpen: action === 'open_demo',
  })

  const handleSetupGuide = () => {
    if (setupGuide) {
      track(trackingEvents.marketplaceModules.openSetupGuide, {
        from: 'marketplace_side_panel_setup_guide',
        module: module,
        origin: pathname,
      })
      window.open(setupGuide, '_blank')
    }
  }

  const resources: ResourceAction[] = [
    {
      id: '1',
      label: pitchDeck?.[0]?.url ? i18n.t('marketplace.revamp.download_overview') : '',
      icon: Download,
      onClick: () => {},
    },
    {
      id: '3',
      label: setupGuide ? i18n.t('marketplace.revamp.setup_guide') : '',
      icon: ExternalLink,
      onClick: handleSetupGuide,
    },
  ]

  const handleDownloadPitchDeck = async () => {
    const pitchDeckUrl = pitchDeck?.[0]?.url

    if (!pitchDeckUrl || !module) {
      return
    }

    await downloadPdf({
      url: pitchDeckUrl,
      module,
      source: 'marketplace_side_panel_download',
      origin: pathname,
    })
  }

  const dynamicResources: ResourceAction[] = resources
    .filter((resource) => {
      if (resource.id === '1' && !pitchDeck?.[0]?.url) {
        return false
      }
      if (resource.id === '3' && !setupGuide) {
        return false
      }
      return true
    })
    .map((resource) => {
      if (resource.id === '1') {
        return {
          ...resource,
          onClick: handleDownloadPitchDeck,
          disabled: !pitchDeck?.[0]?.url,
        }
      }
      return resource
    })

  return (
    <>
      <Box
        flexDirection="column"
        gap="s24"
        paddingX="s16"
        paddingRight="s48"
        style={{ position: 'relative' }}
      >
        {shouldShowNavattic && <Navattic image={navatticImage} onClick={openDemo} />}

        <Resources
          resources={dynamicResources}
          module={module}
          moduleSlug={moduleSlug}
          pageSource={pathname}
          isAuthorized={isAuthorized}
        />

        <SimilarCompanies
          benefit={benefit || ''}
          module={module || ''}
          moduleName={moduleName || ''}
        />
      </Box>
      {shouldShowNavattic && navatticModal}
    </>
  )
}

export default SidePanel
